<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="warning" class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <page-title v-if="showCreateOptions('isRecordShiftsEnabled') && userData.active"
        title="What do you want to create?"
        subtitle="Please select create a shift or job!"
        showIcon
      />
      <page-title v-else
        title="Create Job Ad"
        subtitle="Please select create a job!"
        showIcon
      />

      <div class="buttons_wrapper">
        <el-button
          :class="{ active: type === 'shift' }"
          type="transparent"
          @click="selectType('shift')"
          :disabled="!userData.active"
          :title="!userData.active ? 'User not active' : ''"
          v-if="showCreateOptions('isRecordShiftsEnabled') && userData.active"
        >
          Create a Shift
          <span v-if="type === 'job-seeker'" class="checkmark"
            ><svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                fill="white"
              />
            </svg>
          </span>
        </el-button>
        <el-button
          :class="{ active: type === 'job' }"
          type="transparent"
          @click="selectType('job')"
          :disabled="!showCreateOptions('isRecordJobboardEnabled')"
          :title="!userData.active ? 'User not active' : ''"
          v-if="showCreateOptions('isRecordJobboardEnabled')"
        >
          Create a Job
          <span v-if="type === 'locum'" class="checkmark"
            ><svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                fill="white"
              />
            </svg>
          </span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import PageTitle from "@/components/PageTitle/PageTitle.vue";
import { onMounted, onUnmounted, ref } from "vue";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useRouter } from "vue-router";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    PageTitle,
  },
  setup() {
    const $store = useStore();
    const type = ref("");
    const $router = useRouter();
    const showCreateOptions = (option) => {
      if (userData?.site[option]) {
        return true;
      }

      return false;
    };
    const selectType = (selectedType) => {
      type.value = selectedType;

      if (selectedType == "shift") {
        $router.push({
          name: "job_create",
          params: {
            page: "date",
          },
        });
      } else {
        $store.dispatch("clearJobListingCreatePageData");
        $router.push({
          name: "create_job_listing",
        });
      }
    };
    const goBack = () => {
      $router.push({
        name: "search",
      });
    };
    const userData = $store.getters.GET_USER_DATA;

    onMounted(() => {
      $("body").addClass("background_blue");
    });

    onUnmounted(() => {
      $("body").removeClass("background_blue");
    });
    return {
      selectType,
      goBack,
      type,
      userData,
      showCreateOptions,
    };
  },
};
</script>
